package games.mythical.saga.watcher.sagawatcher.frontend.util

import mui.material.GridProps

inline var GridProps.xs: Any
    get() = TODO("Prop is write-only!")
    set(value) {
        asDynamic().xs = value
    }